import { render, staticRenderFns } from "./Page4.vue?vue&type=template&id=3bc1a009&scoped=true"
import script from "./Page4.vue?vue&type=script&lang=js"
export * from "./Page4.vue?vue&type=script&lang=js"
import style0 from "./Page4.vue?vue&type=style&index=0&id=3bc1a009&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc1a009",
  null
  
)

export default component.exports